module.exports = __webpack_public_path__ + "img/5_growth_catalyst.30896bde.png";